var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2833 11.9997C13.2878 13.5012 12.6961 14.943 11.6384 16.0086C10.5806 17.0742 9.14313 17.6764 7.64168 17.6831C6.14024 17.6764 4.70279 17.0742 3.64501 16.0086C2.58723 14.943 1.99559 13.5012 2.00002 11.9997C1.99559 10.4983 2.58723 9.05644 3.64501 7.99085C4.70279 6.92525 6.14024 6.32302 7.64168 6.31641C9.14313 6.32302 10.5806 6.92525 11.6384 7.99085C12.6961 9.05644 13.2878 10.4983 13.2833 11.9997ZM19.4667 11.9997C19.4667 14.9497 18.2083 17.3497 16.65 17.3497C15.0917 17.3497 13.825 14.9497 13.825 11.9997C13.825 9.04974 15.0917 6.64974 16.65 6.64974C18.2083 6.64974 19.4667 9.04974 19.4667 11.9997ZM22 11.9997C22 14.6414 21.5583 16.7914 21.0083 16.7914C20.4583 16.7914 20.0167 14.6414 20.0167 11.9997C20.0167 9.35807 20.4583 7.20807 21.0083 7.20807C21.5583 7.20807 22 9.35807 22 11.9997Z",
    fill: "#070A26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.52c87492852f4f806da95532412830ec.svg";
export { ForwardRef as ReactComponent };